import classNames from 'classnames';
import React, { ReactElement } from 'react';
import { KeyCode } from '../../types';
import './RadioGroup.scss';
import IRadioGroupProps from './RadioGroupProps';

const RadioGroup = <T extends string = string>({
  onChange,
  name,
  value,
  disabled,
  type = 'vertical',
  children,
  className,
}: IRadioGroupProps<T>) => {
  const classes = classNames(
    {
      'radio-group': true,
      [`radio-group-${type}`]: true,
    },
    className
  );

  function handleChange(val: T) {
    if (!disabled) {
      onChange(val);
    }
  }

  function onKeyPress(event: React.KeyboardEvent) {
    const values: T[] = React.Children.map(
      children as Array<ReactElement & HTMLInputElement>,
      (radio) => radio.props.value
    );
    const currentIndex = value ? values.indexOf(value) : null;
    if (event.keyCode === KeyCode.ARROW_DOWN) {
      event.preventDefault();
      event.stopPropagation();
      const nextIndex = (currentIndex ?? -1) + 1;
      if (nextIndex < values.length) {
        handleChange(values[nextIndex]);
      }
    } else if (event.keyCode === KeyCode.ARROW_UP) {
      event.preventDefault();
      event.stopPropagation();
      const prevIndex = (currentIndex ?? 1) - 1;
      if (values.length > 0 && prevIndex >= 0) {
        handleChange(values[prevIndex]);
      }
    }
  }

  function renderButtons() {
    return React.Children.map(children as Array<ReactElement & HTMLInputElement>, (radio) => {
      return React.cloneElement(radio, {
        key: radio.props.value,
        name,
        checked: radio.props.value === value,
        onChange: handleChange,
        onKeyDown: onKeyPress,
      });
    });
  }

  return <div className={classes}>{renderButtons()}</div>;
};

export default RadioGroup;
